(() => {
  const start = () => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = [...document.querySelectorAll('[data-signature-section], [data-quality-path]')];

    document.querySelectorAll('.why-surface h2, .quality-overview h2, .proof-editorial h2, .release-list h2').forEach((heading) => {
      heading.classList.add('bts58-heading');
    });

    document.querySelectorAll('[data-signature-card]').forEach((card, index) => {
      card.style.setProperty('--bts58-index', index);
      if (!reduced) card.classList.add('bts58-card-ready');
    });
    document.querySelectorAll('.quality-overview__steps article').forEach((step, index) => {
      step.style.setProperty('--bts58-index', index);
    });

    const activate = (section) => {
      section.classList.add('bts58-active');
      section.querySelectorAll('.bts58-heading').forEach((heading) => heading.classList.add('bts58-visible'));
    };

    if (reduced || !('IntersectionObserver' in window)) {
      sections.forEach(activate);
      document.querySelectorAll('.bts58-heading').forEach((heading) => heading.classList.add('bts58-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        activate(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: .18, rootMargin: '0px 0px -8% 0px' });
    sections.forEach((section) => observer.observe(section));

    const headingObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('bts58-visible');
        headingObserver.unobserve(entry.target);
      });
    }, { threshold: .4 });
    document.querySelectorAll('.bts58-heading').forEach((heading) => headingObserver.observe(heading));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
